import { FunctionComponent, lazy } from 'react'
import { Switch, Route } from 'react-router-dom'
import { roomPaths } from './constants'

const WaitingRoomSchedule = lazy(
  () =>
    import('@/modules/Attendance/submodules/Room/pages/WaitingRoomSchedule'),
)
const WaitingRoomImmediate = lazy(
  () =>
    import('@/modules/Attendance/submodules/Room/pages/WaitingRoomImmediate'),
)

const routes = [
  <Route
    path={roomPaths?.scheduled.fullPath}
    key={roomPaths?.scheduled.fullPath}
    exact
    component={WaitingRoomSchedule}
  />,
  <Route
    path={roomPaths?.immediate?.fullPath}
    key={roomPaths?.immediate?.fullPath}
    exact
    component={WaitingRoomImmediate}
  />,
]

const RoomRoutes: FunctionComponent = () => <Switch>{routes}</Switch>

export default RoomRoutes
